/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  List, Checkbox, Segment,
  Header, Divider, Button, Dimmer,
  Loader, Grid
} from "semantic-ui-react";

import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

export class AnalyzerDPConfig extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      isSendingAnalyzerDPConfigDimmerActive: false,
      // ------- Analyzer DP -------
      isTerminationOFFProblemChecked: false,
      isNoPowerSupplyTerminationProblemChecked: false,
      isHighResistanceProblemChecked: false,
      isANotOkProblemChecked: false,
      isBNotOkProblemChecked: false,
      isLongCableProblemChecked: false,
      isNoiseProblemChecked: false,
      isReflectionProblemChecked: false,
    };
  }

  retrieveData = () => {
    fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS + "tsExpertConfig", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        // ------- Analyzer DP -------
        isTerminationOFFProblemChecked: data.isTerminationOFFProblemChecked,
        isNoPowerSupplyTerminationProblemChecked: data.isNoPowerSupplyTerminationProblemChecked,
        isHighResistanceProblemChecked: data.isHighResistanceProblemChecked,
        isANotOkProblemChecked: data.isANotOkProblemChecked,
        isBNotOkProblemChecked: data.isBNotOkProblemChecked,
        isLongCableProblemChecked: data.isLongCableProblemChecked,
        isNoiseProblemChecked: data.isNoiseProblemChecked,
        isReflectionProblemChecked: data.isReflectionProblemChecked,
      }));
  }

  // ------ Toggle Analyzer DP Checkboxes ---------
  toggleIsOffPositionTermProblemCheckbox = () => {
    this.setState({ isTerminationOFFProblemChecked: !this.state.isTerminationOFFProblemChecked });
  }

  toggleIsTermWithoutPowerSupplyProblemCheckbox = () => {
    this.setState({ isNoPowerSupplyTerminationProblemChecked: !this.state.isNoPowerSupplyTerminationProblemChecked });
  }

  toggleIsMoreThan2TermProblemCheckbox = () => {
    this.setState({ isHighResistanceProblemChecked: !this.state.isHighResistanceProblemChecked });
  }

  toggleIsShortCircuitAProblemCheckbox = () => {
    this.setState({ isANotOkProblemChecked: !this.state.isANotOkProblemChecked });
  }

  toggleIsShortCircuitBProblemCheckbox = () => {
    this.setState({ isBNotOkProblemChecked: !this.state.isBNotOkProblemChecked });
  }

  toggleIsLongCableProblemCheckbox = () => {
    this.setState({ isLongCableProblemChecked: !this.state.isLongCableProblemChecked });
  }

  toggleIsNoiseProblemCheckbox = () => {
    this.setState({ isNoiseProblemChecked: !this.state.isNoiseProblemChecked });
  }

  toggleIsReflectionProblemCheckbox = () => {
    this.setState({ isReflectionProblemChecked: !this.state.isReflectionProblemChecked });
  }

  // Save the TS Expert Configuration
  saveAnalyzerDpTsExpertConfiguration = () => {
    this.showSendingAnalyzerDPConfigDimmer();

    let data = {
      isTerminationOFFProblemChecked: this.state.isTerminationOFFProblemChecked,
      isNoPowerSupplyTerminationProblemChecked: this.state.isNoPowerSupplyTerminationProblemChecked,
      isHighResistanceProblemChecked: this.state.isHighResistanceProblemChecked,
      isANotOkProblemChecked: this.state.isANotOkProblemChecked,
      isBNotOkProblemChecked: this.state.isBNotOkProblemChecked,
      isLongCableProblemChecked: this.state.isLongCableProblemChecked,
      isNoiseProblemChecked: this.state.isNoiseProblemChecked,
      isReflectionProblemChecked: this.state.isReflectionProblemChecked,
    };

    fetch(Constants.ANALYZER_REQUEST_IP_ADDRESS + "tsExpertConfig_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify(data)
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY);
      })
      .catch((error) => {
        alert(Strings.TS_EXPERT_CONFIG_SAVE_ERROR + Strings.REASON + error);
      })
      .finally(this.hideSendingAnalyzerDPConfigDimmer);
  }

  showSendingAnalyzerDPConfigDimmer = () => this.setState({ isSendingAnalyzerDPConfigDimmerActive: true });

  hideSendingAnalyzerDPConfigDimmer = () => this.setState({ isSendingAnalyzerDPConfigDimmerActive: false });

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
  }

  render() {
    return (
      <Segment doubling textAlign="left">
        <Header as='h2' textAlign="center" color="teal">
          {Strings.TS_EXPERT_DP}
        </Header>
        <Divider clearing />

        <Segment id="problems-list" style={listSegmentStyle} basic>

          <List divided verticalAlign='middle'>

            <List.Item>
              <List.Content>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.TERMINATION_OFF_LIST_HEADER}</List.Header>
                    {Strings.TERMINATION_OFF_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleIsOffPositionTermProblemCheckbox}
                      checked={this.state.isTerminationOFFProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Content>
            </List.Item>

            <List.Item>
              <List.Content>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.NO_POWER_SUPPLY_LIST_HEADER}</List.Header>
                    {Strings.NO_POWER_SUPPLY_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleIsTermWithoutPowerSupplyProblemCheckbox}
                      checked={this.state.isNoPowerSupplyTerminationProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Content>
            </List.Item>

            <List.Item>
              <List.Content>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.HIGH_RESISTANCE_LIST_HEADER}</List.Header>
                    {Strings.HIGH_RESISTANCE_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleIsMoreThan2TermProblemCheckbox}
                      checked={this.state.isHighResistanceProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Content>
            </List.Item>

            <List.Item>
              <List.Content>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.A_NOT_OK_LIST_HEADER}</List.Header>
                    {Strings.A_NOT_OK_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleIsShortCircuitAProblemCheckbox}
                      checked={this.state.isANotOkProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Content>
            </List.Item>

            <List.Item>
              <Grid columns={2}>
                <Grid.Column width={14}>
                  <List.Header>{Strings.B_NOT_OK_LIST_HEADER}</List.Header>
                  {Strings.B_NOT_OK_LIST_CONTENT}
                </Grid.Column>
                <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                  <Checkbox
                    toggle
                    onChange={this.toggleIsShortCircuitBProblemCheckbox}
                    checked={this.state.isBNotOkProblemChecked} />
                </Grid.Column>
              </Grid>
            </List.Item>

            <List.Item>
              <Grid columns={2}>
                <Grid.Column width={14}>
                  <List.Header>{Strings.LONG_CABLE_LIST_HEADER}</List.Header>
                  {Strings.LONG_CABLE_LIST_CONTENT}
                </Grid.Column>
                <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                  <Checkbox
                    toggle
                    onChange={this.toggleIsLongCableProblemCheckbox}
                    checked={this.state.isLongCableProblemChecked} />
                </Grid.Column>
              </Grid>
            </List.Item>

            <List.Item>
              <Grid columns={2}>
                <Grid.Column width={14}>
                  <List.Header>{Strings.NOISE_LIST_HEADER}</List.Header>
                  {Strings.NOISE_LIST_CONTENT}
                </Grid.Column>
                <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                  <Checkbox
                    toggle
                    onChange={this.toggleIsNoiseProblemCheckbox}
                    checked={this.state.isNoiseProblemChecked} />
                </Grid.Column>
              </Grid>
            </List.Item>

            <List.Item>
              <Grid columns={2}>
                <Grid.Column width={14}>
                  <List.Header>{Strings.REFLECTION_LIST_HEADER}</List.Header>
                  {Strings.REFLECTION_LIST_CONTENT}
                </Grid.Column>
                <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                  <Checkbox
                    toggle
                    onChange={this.toggleIsReflectionProblemCheckbox}
                    checked={this.state.isReflectionProblemChecked} />
                </Grid.Column>
              </Grid>
            </List.Item>

          </List>

        </Segment>

        <Button
          fluid
          color="teal"
          content={Strings.SAVE}
          onClick={this.saveAnalyzerDpTsExpertConfiguration} />

        <Dimmer active={this.state.isSendingAnalyzerDPConfigDimmerActive} >
          <Loader size="big">{Strings.SENDING_TS_EXPERT_CONFIG_WAITING}</Loader>
        </Dimmer>

      </Segment>
    );
  }
}

const listSegmentStyle = {
  overflowY: "scroll",
  height: "56vh"
};

export default AnalyzerDPConfig;